import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CreatableSelect from "react-select/creatable";

import Select from "react-select";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
  Spinner,
  Form,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import toast from "react-hot-toast";
import { RestroUsers } from "../../../../services/DatabaseService/RestroUsers";

const RUIValidTillExtend = () => {
  const { apiKey } = useParams();
  const navigate = useNavigate();

  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isCanceling, setIsCanceling] = useState(false);
  const options = [
    { value: "1", label: "Purchase" },
    { value: "2", label: "Trade" },
    { value: "3", label: "Import" },
    { value: "4", label: "Export" },
  ];

  // Validation Schema
  const validationSchema = Yup.object().shape({
    tenantName: Yup.string().required("Tenant Name is required"),
    validTill: Yup.date().required("Valid Till date is required"),
    remarks: Yup.string().required("Remarks is Required"),
  });

  useEffect(() => {
    console.log("use");
    console.log(apiKey);
    const fetchUserDetail = async () => {
      try {
        const response = await RestroUsers.getByApiKey(apiKey);
        console.log(apiKey);
        console.log("fired");
        console.log(response);
        formik.setValues({
          tenantName: response?.tenantName || "",
          validTill: response?.validTill
            ? new Date(response.validTill).toISOString().split("T")[0]
            : "",
          apiKey: response?.apiKey || apiKey,
        });
      } catch (error) {
        console.error("Error fetching user detail:", error);
        toast.error("Failed to fetch user details");
      }
    };

    if (apiKey) {
      setIsEditing(true);
      fetchUserDetail();
    }
  }, [apiKey]);

  const formik = useFormik({
    initialValues: {
      tenantName: "",
      validTill: "",
      apiKey: "",
      remarks: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsSaving(true);

        const payload = {
          newValidTill: new Date(values.validTill).toISOString(),
          apiKey: values.apiKey || " ",
          remarks: values.remarks,
        };

        if (isEditing) {
          await RestroUsers.Extend(payload);
          toast.success("Restro User Updated Successfully");
        } else {
          toast.info("Create functionality not yet implemented");
        }

        navigate("/restrousers");
      } catch (error) {
        console.error("Error:", error);
        toast.error(
          error?.response?.data?.message ||
            error?.message ||
            "Error saving restro user"
        );
      } finally {
        setIsSaving(false);
      }
    },
  });

  const breadcrumbItems = [{ title: "Back to List", link: "/restrousers" }];

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title={isEditing ? "Edit Restro User" : "Add Restro User"}
          pageTitle="Restro Users"
          breadcrumbItems={breadcrumbItems}
        />
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={6} md={12} className="mb-3">
                      <Label for="tenantName">
                        Tenant Name: <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        id="tenantName"
                        name="tenantName"
                        placeholder="Enter tenant name"
                        value={formik.values.tenantName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.tenantName && formik.errors.tenantName
                        }
                        readOnly
                      />
                      {formik.touched.tenantName &&
                        formik.errors.tenantName && (
                          <div className="text-danger">
                            {formik.errors.tenantName}
                          </div>
                        )}
                    </Col>

                    <Col lg={6} md={12} className="mb-3">
                      <Label htmlFor="validTill">Valid Till Date:</Label>
                      <Input
                        type="date"
                        id="validTill"
                        name="validTill"
                        value={formik.values.validTill}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                    <Col lg={6} md={12} className="mb-3">
                      <Label htmlFor="remarks">
                        Remarks: <span className="text-danger">*</span>
                      </Label>
                      <CreatableSelect
                        id="remarks"
                        name="remarks"
                        options={options}
                        placeholder="Search for services"
                        isSearchable
                        value={options.find(
                          (opt) => opt.value === formik.values.remarks
                        ) || {
                          value: formik.values.remarks,
                          label: formik.values.remarks,
                        }
                      } 
                        onChange={(selectedOption) => {
                          formik.setFieldValue(
                            "remarks",
                            selectedOption?.value || ""
                          ); 
                        }}
                        onBlur={() => formik.setFieldTouched("remarks", true)}
                      />
                      {formik.touched.remarks && formik.errors.remarks && (
                        <div className="text-danger">
                          {formik.errors.remarks}
                        </div>
                      )}
                    </Col>
                  </Row>

                  <div className="text-end mt-4">
                    <Button
                      type="submit"
                      className="me-2"
                      color="success"
                      disabled={isSaving}
                    >
                      {isSaving ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => {
                        setIsCanceling(true);
                        navigate("/restrousers");
                      }}
                      disabled={isCanceling || isSaving}
                    >
                      {isCanceling ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Canceling...
                        </>
                      ) : (
                        "Cancel"
                      )}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default RUIValidTillExtend;
